import { createGlobalStyle } from "styled-components";
import theme from "./index";

export const GlobalStyle = createGlobalStyle`
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
html,
body {
  font-family: 'Montserrat', sans-serif;
  scroll-behavior: smooth;
  padding: 0;
  margin: 0;
  overflow-x: hidden;
}
ul {
  list-style: none;
}
  button {
    cursor: pointer;
    border: 0;
    border-radius: 0;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: 600;
    color: red;
    line-height: 1.1;
  }

  p {
    font-weight: 400;
    color: red;
  }

  *::-webkit-scrollbar {
    width: 0.3rem;
    height: 7px;
    }
  *::-webkit-scrollbar-track {
    background-color: transparent;
  }
  *::-webkit-scrollbar-thumb {
    border-radius: 1rem;
    background-color: ${theme.colors.purple.primary};
  }
`;
